module.exports = __webpack_public_path__ + "img/bj_zuoda_yao@2x.6e72ac3e.png";